import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'scripts/bem'

// load the stylin
import './style.css'

// load the common blocks
import * as blocks from './components'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
